import {
    createApp
} from 'vue'
import App from './App.vue'
import {
    createI18n
} from 'vue-i18n';
import router from './router'
import store from './store'
import "tailwindcss/tailwind.css";
import "@/sass/index.scss";
import ElementPlus from 'element-plus'
import 'normalize.css/normalize.css'
import animated from 'animate.css'
import 'element-plus/dist/index.css'
import {
    Popup
} from "vant"
import 'vant/lib/index.css';
const i18n = createI18n({
    locale: 'zh', // 默认语言
    messages: {
        en: require('./lang/en.json'),
        zh: require('./lang/zh.json'),
        // 添加其他语言
    },
});
createApp(App).use(store).use(i18n).use(animated).use(Popup).use(ElementPlus).use(router).mount('#app')